import type { OrderStatus } from '@shop-monorepo/types';
import { Tag } from 'antd';
import React from 'react';

export const STATUS_CONFIG: Record<OrderStatus, { color: string; label: string }> = {
  pending: { color: 'orange', label: 'Очікує' },
  confirmed: { color: 'blue', label: 'Підтверджено' },
  paid: { color: 'green', label: 'Прийнято до оплати' },
  shipped: { color: 'purple', label: 'Відправлено' },
  received: { color: 'cyan', label: 'Отримано' },
  refused: { color: 'volcano', label: 'Відмовився покупець' },
  cancelled: { color: 'red', label: 'Скасовано' },
};

interface OrderStatusTagProps {
  status: OrderStatus;
}

export const OrderStatusTag: React.FC<OrderStatusTagProps> = ({ status }) => {
  const config = STATUS_CONFIG[status];
  if (!config) {
    return <Tag>{status}</Tag>;
  }
  return <Tag color={config.color}>{config.label}</Tag>;
};

export const ORDER_STATUS_OPTIONS = Object.entries(STATUS_CONFIG).map(([value, { label }]) => ({
  label,
  value,
}));
